import React from 'react';
import About1 from '../components/about_components/About1';
import About2 from '../components/about_components/About2';
import Team from '../components/about_components/Team';
import Message from '../components/about_components/Message';
import CoreValues from '../components/about_components/CoreValues';

const About = () => {
  return (
    <>
      <About1 />
      <About2 />
      {/* <CoreValues /> */}
      <Message />
      <Team />
    </>
  );
};

export default About;
